import { parseISO } from "date-fns";
import type { CalendarItem, CalendarItems } from "../components/calendar/calendar.types";

export function parseCalendarEvents(items: CalendarItems) {
    if (!items) return [];

    const events = items.map((value) => {
        return {
            id: value.id,
            title: handleTitle(value),
            originalTitle: value?.title,
            start: parseISO(value.start_date),
            end: parseISO(value.end_date),
            start_date: value.start_date,
            end_date: value.end_date,
            color: setColorEvent(value),
            allDay: value.is_all_day,
            is_first_session: value?.is_first_session,
            technicianAvatar: value?.technician?.user_id?.avatar,
            internal_meetings_participants: handleInternalMeetingsParticipants(value),
            status: value?.status,
            service: value?.service,
            treatment: value?.treatment,
            technician: value?.technician,
            notes: value?.notes,
            clinic_id: value?.clinic_id,
            meeting_id: value?.meeting_id,
            meeting_url: value?.meeting_url,
            lead: value?.lead,
        };
    });

    return events;
}

export const getShortName = (firstName?: string, lastName?: string) => {
    if (!firstName && !lastName) return undefined;
    
    const firstWord = firstName?.trim().split(" ")[0] ?? "";
    const lastNameParts = lastName?.trim().split(" ").filter(Boolean) ?? [];
    const lastWord = lastNameParts[lastNameParts.length - 1] ?? "";
    
    const shortName = [firstWord, lastWord].filter(Boolean).join(" ");
    return shortName || undefined;
};

const handlePersonName = (value: CalendarItem) => {
    const clientId = value.treatment?.client?.client_id;
    const clientFirstName = value.treatment?.client?.user_id?.first_name;
    const clientLastName = value.treatment?.client?.user_id?.last_name;
    const hasClient = clientId || clientFirstName || clientLastName;
    
    if (hasClient) return getShortName(clientFirstName, clientLastName);
    
    const leadFirstName = value.lead?.first_name;
    const leadLastName = value.lead?.last_name;
    return getShortName(leadFirstName, leadLastName);
};

const handleTitle = (value: CalendarItem) => {
    const clientId = value.treatment?.client?.client_id;
    const personName = handlePersonName(value);
    const title = value?.title;
    const service = value?.service?.name;
    
    const values = [clientId, personName, title, service].filter((val) => val !== undefined && val !== null);
    
    return values.join("\n");
};

export const missedStatusColor = "#e63131"; // red
export const staffUnavailableStatusColor = "#FF7373"; // light red

const setColorEvent = (event: CalendarItem) => {
    if (event.status === "cancelled" || event.status === "missed") {
        return missedStatusColor;
    }
    if(event.status === "staff_unavailable") {
        return staffUnavailableStatusColor;
    }

    const servicesThatPrevailsColor = [33, 35, 39]; // NFB, qEEG, qEEG - Primeira

    if (servicesThatPrevailsColor.includes(event?.service?.id as number)) {
        return event?.service?.color;
    }

    if (!event.service) {
        return "#d1cfcf"; // grey
    }

    return event?.technician?.color || event?.service?.color;
};

const handleInternalMeetingsParticipants = (event: CalendarItem) => {
    if (event.internal_meetings_participants?.length > 0) {
        return event.internal_meetings_participants.map((participant) => participant?.technicians_id?.user_id?.avatar);
    }
    return [];
};
